import _ from 'lodash'
import account from './account'
import actions from './actions'
import applications from './applications'
import billing from './billing'
import builds from './builds'
import domains from './domains'
import incidents from './incidents'
import instances from './instances'
import packages from './packages'
import repositories from './repositories'
import tasks from './tasks'
import teams from './teams'
import tokens from './tokens'
import wordpress from './wordpress'

export default _.merge(account, actions, applications, builds, billing, domains,
  incidents, instances, packages, repositories, tasks, teams, tokens, wordpress)
